import type { LinkTarget } from "@/components/link";
import type { AddToListsTarget } from "@/lib/add-to-lists-target";
import { pickEnum, pickString } from "@/lib/search-params";
import { getSafeRedirectPath } from "@garimpa/lib/getSafeRedirectPath";

const DISCOGS_CALLBACK_VALUES = ["connected", "error"] as const;

export function normalizeWelcomeSearch(search: Record<string, unknown>) {
  return {
    redirect: getSafeRedirectPath(pickString(search.redirect)),
    discogs: pickEnum(search.discogs, DISCOGS_CALLBACK_VALUES),
  };
}

export function postOnboardingRecordLink(target: AddToListsTarget): LinkTarget {
  if (target.entityType === "release") {
    return { to: "/release/$id", params: { id: target.releaseId } };
  }
  return { to: "/work/$id", params: { id: target.workId } };
}
